/**
 * Maps answerQuality to Convo AI feedback value
 */
export const mapAnswerQualityToFeedbackValue = (
	answerQuality: 'good' | 'bad' | 'general',
): 'LIKE' | 'DISLIKE' => {
	return answerQuality === 'good' ? 'LIKE' : 'DISLIKE';
};
